import SubtitleService from "@/services/media/subtitle.service";

export const subtitle = {
    namespaced: true,
    state: {
        subtitleURL: null,
        subtitleName: "",
        subtitleExists: false,
        sync: 0,
    },
    mutations: {
        setSubtitleURL(state, url) {
            state.subtitleURL = url;
        },
        setSubtitleName(state, name) {
            state.subtitleName = name;
        },
        setSubtitleExists(state, value) {
            state.subtitleExists = value;
        },
        setSync(state, value) {
            state.sync = value;
        },
    },
    actions: {
        async selectSubtitle({ commit, dispatch }, name) {
            commit("setSubtitleName", name);
            commit("setSubtitleURL", null);
            commit("setSubtitleExists", false);

            return await dispatch("reloadSubtitle");
        },
        async reloadSubtitle({ state, commit }) {
            if (!state.subtitleName) {
                commit("setSubtitleURL", null);
                commit("setSubtitleExists", false);

                return false;
            }

            const result = await SubtitleService.get(state.subtitleName, state.sync);
            if (!result) {
                commit("setSubtitleURL", null);
                commit("setSubtitleExists", false);

                return false;
            }
            commit("setSubtitleURL", result.url);
            commit("setSubtitleName", result.name);
            commit("setSubtitleExists", true);

            return true;
        },

        async adjustSync({ state, commit, dispatch }, ms) {
            commit("setSync", state.sync + ms);

            return await dispatch("reloadSubtitle");
        },

        async resetSync({ commit, dispatch }) {
            commit("setSync", 0);

            return await dispatch("reloadSubtitle");
        },

        async findSubtitle({ commit }, { file, sync = 0 }) {
            // 기존 자막 상태 초기화
            commit("setSubtitleExists", false);
            commit("setSubtitleName", "");
            commit("setSubtitleURL", "");
            commit("setSync", sync);

            if (!file) {
                return false;
            }

            const result = await SubtitleService.find(file, sync);

            if (!result) {
                commit("setSubtitleURL", null);
                commit("setSubtitleExists", false);
                return false;
            }

            commit("setSubtitleURL", result.url);
            commit("setSubtitleName", result.name);
            commit("setSubtitleExists", true);

            return true;
        },
    },
};